import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-curtailment-support-doc',
    templateUrl: './curtailment-support-doc.component.html',
    styleUrls: ['./curtailment-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CurtailmentSupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
